<template>
    <div :class="view_class_view.div_container">

      <div class="grid grid-cols-1 sm:gap-10">
        <div class="mt-10">
          <ChooseButton
            :buttons="buttonsEconomicInformation"
            v-on:choose-button="getValueChooseButton($event)"
            label="Periodo de ingreso:"
          />
          <div class="content-text" style="float: left">
            <template v-if="economicInformationModelValidation.income_frecuency.$dirty">
              <div
                class="input-errors"
                v-for="error of economicInformationModelValidation.income_frecuency.$errors"
                :key="error.$uid"
              >
                <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-10">
        <div class="mt-10">
          <p class="label-input w-full">Ingreso Bruto Mensual:</p>
          <input
            type="text"
            style="color: #3b3b3b"
            id="monthlygrossincome"
            class="
              outline-none
              shadow-md
              border-2
              rounded-lg
              px-3
              py-2
              w-full
            "
            v-money="money"
            @blur="validationIsgreaterthan()"
            onkeypress="if(this.value.length==10) return false;return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
            v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: specialValidations.monthlygrossincome.messages.length > 0,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]: specialValidations.monthlygrossincome.contentErros,
                [view_class_view.classInputs.default ]: specialValidations.monthlygrossincome.contentErros }"
          />
          <div class="content-text" style="float: left">
            <div v-if="specialValidations.monthlygrossincome.messages">
              <span
                :class="view_class_view.div_container_error.text_error"
                v-for="(errors, index) in specialValidations.monthlygrossincome
                  .messages"
                :key="errors"
                :id="'label_error_monthlygrossincome_' + index"
                >{{ errors }}</span
              >
            </div>
          </div>
        </div>

        <div class="mt-10">
          <p class="label-input w-full">Liquidez mensual:</p>
          <input
            type="text"
            style="color: #3b3b3b"
            id="monthlyliquidity"
            class="
              outline-none
              shadow-md
              border-2
              rounded-lg
              py-2
              w-full
              px-3
              focus:border-cherryColor
            "
            v-money="money"
            @blur="validationIsgreaterthan()"
            onkeypress="if(this.value.length==10) return false;return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
            v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: specialValidations.monthlyliquidity.messages.length > 0,
                [view_class_view.classInputs.default + view_class_view.classInputs.valid]: specialValidations.monthlyliquidity.contentErros,
                [view_class_view.classInputs.default ]: specialValidations.monthlyliquidity.contentErros }"
          />
          <div class="content-text" style="float: left">
            <div v-if="specialValidations.monthlyliquidity.messages">
              <span
                :class="view_class_view.div_container_error.text_error"
                v-for="(errors, index) in specialValidations.monthlyliquidity
                  .messages"
                :key="errors"
                :id="'label_error_monthlyliquidity_' + index"
                >{{ errors }}</span
              >
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>

import ChooseButton from './Forms/ChooseButton.vue';
import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { VMoney } from "v-money";
import Swal from "sweetalert2";

export default {
  name: "EconomicInformationComponent",
  props: {
    view_class_view: {
      type: Object,
      default() {
        return {};
      },
    },
    validations: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props) {
    const money = ref({
      decimal: ".",
      thousands: ",",
      prefix: "",
      suffix: "",
      precision: 0,
      masked: false,
    });

    let specialValidations = ref({
      monthlygrossincome: {
        valid: null,
        messages: [],
        contentErrors: false,
      },
      monthlyliquidity: {
        valid: null,
        messages: [],
        contentErrors: false,
      },
    });

    let buttonsEconomicInformation = ref([
      { id: "button_semanal", value: "Semanal", text: "Semanal" },
      { id: "button_quincenal", value: "Quincenal", text: "Quincenal" },
      { id: "button_mensual", value: "Mensual", text: "Mensual" },
    ]);
    
    let economicInformationModel = ref({
        liquidity: "",
        monthly_income: "",
        income_frecuency: "",
    });
    
    let economicInformationModelValidation = useVuelidate(props.validations, economicInformationModel);

    function getValueChooseButton(event) {
        economicInformationModel.value.income_frecuency = event;
    }

    function validationIsgreaterthan() {
      specialValidations.value.monthlygrossincome.messages = []; //Arreglo de mensajes de errores
      specialValidations.value.monthlyliquidity.messages = []; //Arreglo de mensajes de errores
      specialValidations.value.monthlygrossincome.valid = true;
      specialValidations.value.monthlyliquidity.valid = true;

      let monthlygrossincome = parseFloat(
        fomartNumber(document.getElementById("monthlygrossincome").value)
      );
      let monthlyliquidity = parseFloat(
        fomartNumber(document.getElementById("monthlyliquidity").value)
      );

      if (monthlygrossincome == 0) {
        specialValidations.value.monthlygrossincome.valid = true;
        specialValidations.value.monthlygrossincome.contentErros = false;
        specialValidations.value.monthlygrossincome.messages.push(
          "El ingreso bruto tiene que ser mayor a $0"
        );
      }
      if (monthlygrossincome > 1) {
        specialValidations.value.monthlygrossincome.valid = true;
        specialValidations.value.monthlygrossincome.contentErros = true;
      }
      if (monthlyliquidity === 0) {
        specialValidations.value.monthlyliquidity.valid = true;
        specialValidations.value.monthlyliquidity.contentErros = false;
        specialValidations.value.monthlyliquidity.messages.push(
          "El campo liquidez mensual tiene que ser mayor a $0"
        );
      }
      if (monthlyliquidity > 1) {
        specialValidations.value.monthlyliquidity.valid = true;
        specialValidations.value.monthlyliquidity.contentErros = true;
      }
      if (monthlygrossincome < monthlyliquidity) {
        Swal.fire({
          title: "Aviso",
          text: "El ingreso bruto tiene que ser mayor a liquidez mensual",
          icon: "warning",
          confirmButtonColor: "#FEB72B",
        });
        monthlygrossincome = monthlygrossincome.value;
        monthlyliquidity = monthlyliquidity.value;

        specialValidations.value.monthlygrossincome.valid = true;
        specialValidations.value.monthlygrossincome.contentErros = false;
        specialValidations.value.monthlygrossincome.messages.push(
          "El ingreso bruto tiene que ser mayor a liquidez mensual"
        );
      } else {
        economicInformationModel.value.monthly_income = monthlygrossincome;
        economicInformationModel.value.liquidity = monthlyliquidity;
      }
    }

    function fomartNumber(value) {
      var regex = /^[,.]+$/;
      if (regex.test(value) != true) {
        value = value.replace(/[^0-9.]+/, "");
      }
      return value;
    }

    function execute_validation() {
      economicInformationModelValidation.value.$validate();
      validationIsgreaterthan();
      if(economicInformationModelValidation.value.$errors.length > 0){
        return false;
      }

      return economicInformationModel.value;
    }

    return {
        specialValidations,
        economicInformationModelValidation,
        economicInformationModel,
        money,
        buttonsEconomicInformation,
        getValueChooseButton,
        validationIsgreaterthan,
        execute_validation
    }
  },
  directives: { money: VMoney },
  components:{
    ChooseButton
  }
};
</script>